import { TGroupedNotifications, TNotificationsResponse } from '../../types'

export const tagsAdapter =
  (groupedNotifications: TGroupedNotifications, notification: TNotificationsResponse): TGroupedNotifications => {
    const countedStory = groupedNotifications[notification.notification_type ?? '']?.[notification.notification_type ?? '']

    return {
      ...groupedNotifications,
      ...(notification.notification_type && {
        [notification.notification_type]: {
          ...groupedNotifications[notification.notification_type],
          // group by campaign_id and count
          [notification.notification_type]: {
            ...notification,
            count: (countedStory?.count ?? 0) + 1,
            ids: [...(countedStory?.ids ?? []), { id: notification.id, notification_type: notification.notification_type }],
            last_updated: Math.max(countedStory?.last_updated ?? 0, new Date(notification.story?.updated_at ?? new Date()).getTime()),
            card: {
              title: 'Tag',
              subtitle: notification.notification_type ?? '',
              icon: 'tag',
              zoneId: notification.story?.campaign?.label_id ?? '',
              count: countedStory?.count ? `${countedStory.count + 1} Stories` : '1 Story'
            }
          }
        }
      })
    }
  }
